import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
//import ReactDOM from 'react-dom';
//import axios from 'axios';

import {useracc, postApi, putApi, consoleLog} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Button from 'react-bootstrap/Button';
//import Form from 'react-bootstrap/Form';
//import FormControl from 'react-bootstrap/FormControl';

//import './css/index.css';
//import './css/header.css';

export default class AccountInvite extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
		let url = window.location.pathname.split('/');
    this.state = {
			status: false,
      key: url[2]?url[2]:'', //this.props.match.params.key,
      invite: false,
		};
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});
		
		let params = new URLSearchParams();
    params.append('join',this.state.key);
		const x = await putApi('/v3/account/invite', params);
    consoleLog(x.status, x.data);
    this.setState({status: true, invite: x.status===200?true:false});
    if( x.status === 200 ) window.location.href = `/`;
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		/*const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});*/
		

	}

	componentWillUnmount() {
	}


	render() {
		
		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Dashboard</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item">{/*<Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link>*/}</li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
							<Row>
									
								<Col xs={12}>
                  <div className="card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Invites</span>
													<p className="fs-13 text-muted mb-0">Confirming your invite</p>
												</div>
                      </div>
                    </div>
                  </div>
                </Col>
							</Row>
							
              {this.state.invite === false &&
                <Row>
                  <Col xs={12}>
                    <div className="card custom-card custom-frame">
                      <div className="card-header justify-content-between">
                        <div className="card-title">
                          Error with your station invite
                        </div>
                      </div>
                      <div className="card-body">
                        <Row>
                          <Col>
                            <div className="alert alert-danger alert-dismissible fade show custom-alert-icon shadow-sm" role="alert">
                              <svg className="svg-danger" xmlns="http://www.w3.org/2000/svg" height="1.5rem" viewBox="0 0 24 24" width="1.5rem" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"></path></svg>
                              Invalid key provided
                              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"><i className="bi bi-x"></i></button>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              }
						</div>
					</div>
				}
			</>
		);
	}
}